import axios from '@Services/axios';

export const TITLE_GET_LOADING = 'title/TITLE_GET_LOADING';
export const TITLE_GET_SUCCESS = 'title/TITLE_GET_SUCCESS';
export const TITLE_GET_ERROR = 'title/TITLE_GET_ERROR';

const initialState = {
    titles: [],
    
    isGetInProgress: false,
    isGetComplete: false,
    
    error: ''
};

export function reduxThunkReducer(state = initialState, action) {
    switch (action.type) {
        
        case TITLE_GET_LOADING: {
            return {
                ...state,
                isGetInProgress: true,
                isGetComplete: false,
                error: '',
            };
        }
        case TITLE_GET_SUCCESS: {
            return {
                ...state,
                isGetInProgress: false,
                isGetComplete: true,
                titles: action?.titles || [],
            };
        }
        case TITLE_GET_ERROR: {
            return {
                ...state,
                isGetInProgress: false,
                isGetComplete: false,
                error: action?.error || '',
            };
        }
        default: {
            return {...state};
        }
    }
}

////////////////////////////////////////////////////////////////////
const URL_API = process.env.REACT_APP_API_ENDPOINT;

export const getTitles = () => {
  return (dispatch, getState) => {
    const state = getState();
    
    dispatch({ 
      type: TITLE_GET_LOADING
    });
    axios.post(`${URL_API}/listeTitres`,
      {}).then(
      response => {
        console.log("response LISTE TITRES", response?.data?.données);

        if (response?.data?.données) {
          const data = response?.data?.données;
          const titles = [];
          data.map((oneTitle, index) => {
            titles.push({value: oneTitle?.id || 0, label: oneTitle?.libellé || ''});
          });
          dispatch({ 
            type: TITLE_GET_SUCCESS,
            titles: titles
          });
        } else {
          dispatch({ type: TITLE_GET_ERROR, error: "Erreur lors de la récupération de la liste des titres" });
        }
    },
    error => {
      dispatch({ type: TITLE_GET_ERROR, error: error?.response?.data });
    });
  };
};

